/**
 * Data/hora curta usada em todo o chat de Ocorrências ("22/09, 14:43").
 * Estava copiada em `MessageItem`, `SubjectThread` e `SubjectCard` — mesma
 * função com nomes diferentes. Aceita `null`/data inválida devolvendo string
 * vazia, que é como os call sites já tratavam o caso.
 */
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/** Só a data, com ano ("22/09/2026") — colunas "Aberto em" das tabelas. */
export function formatDate(value: string | null | undefined): string {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}
